#import "@core/schema/fragments/CustomerFull.graphql"

mutation (
  $input: CustomerCreateB2CInput!
) {
  signUp(
    input: $input
  ) {
    ...CustomerFull
  }
}
